// Przestrzeń nazw 'statistics': ekran Statystyki. Kolejność jak w mockupie (renderStatystyki):
// kafelki z deltami, sprawy według tematu, efekt dla urzędu, dni tygodnia, pytania mieszkańców,
// pytania bez odpowiedzi, powody przekazań, języki, oddzwonienia.
export default {
  // Podpis pod deltą kafelka, klucze to presety zakresu. Mockup: „vs wczoraj o tej porze" /
  // „vs poprzednie 7 dni" / „vs poprzednie 30 dni".
  deltaCaption: {
    // VERIFY: „24 godz.", „3 dni", „rok" i „własny" własne. Nasze „24 godz." to okno kroczące,
    // więc porównujemy z poprzednimi 24 godzinami, a nie „wczoraj o tej porze".
    '24h': 'vs poprzednie 24 godz.',
    '3d': 'vs poprzednie 3 dni',
    '7d': 'vs poprzednie 7 dni',
    '30d': 'vs poprzednie 30 dni',
    '1y': 'vs poprzedni rok',
    custom: 'vs poprzedni okres',
  },

  kpis: {
    calls: 'Rozmowy',
    effectiveness: {
      label: 'Skuteczność bota',
      // VERIFY: brak w mockupie. Mianownikiem są odebrane rozmowy, nie wszystkie, i kafelek
      // musi to powiedzieć.
      note: 'z odebranych rozmów, zamkniętych bez urzędnika',
    },
    rating: 'Średnia ocena',
    afterHours: 'Rozmowy poza godzinami',
  },

  topics: {
    title: 'Sprawy według tematu',
    // VERIFY: mockup ma „Liczba rozmów i skuteczność bota w każdej kategorii"; skuteczności
    // per temat nie da się wyliczyć z żadnego endpointu, więc jej nie obiecujemy.
    hint: 'Liczba rozmów w każdej kategorii',
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać tematów.',
      loading: 'Ładowanie tematów…',
      empty: 'Brak tematów w tym okresie.',
    },
  },

  impact: {
    title: 'Efekt dla urzędu',
    hint: 'Szacunek na podstawie wybranego okresu',
    columns: {
      measure: 'Wskaźnik',
      value: 'Wartość',
    },
    rows: {
      // VERIFY: mockup ma „Połączenia, które nie trafiły do sekretariatu". Metryka nie ma
      // kierunku, więc to zdanie byłoby nieprawdą dla każdej rozmowy przekazanej dalej.
      callsReceived: 'Odebrane rozmowy',
      casesClosed: 'Sprawy zamknięte bez pracy urzędnika',
      timeRecovered: 'Szacowany odzyskany czas pracy',
      afterHours: 'Telefony odebrane poza godzinami pracy',
      missed: 'Nieodebrane połączenia',
    },
    // Format czasu jak w mockupie: „≈ 1 godz. 30 min".
    timeRecovered: '≈ {{hours}} godz. {{minutes}} min',
    // Mockup: „Przyjęto ostrożnie 8 minut pracy urzędnika na jedną sprawę załatwioną przez bota."
    // Formy fleksyjne, bo stała `MINUTES_SAVED_PER_CASE` może się zmienić.
    assumption_one:
      'Przyjęto ostrożnie {{count}} minutę pracy urzędnika na jedną sprawę załatwioną przez bota.',
    assumption_few:
      'Przyjęto ostrożnie {{count}} minuty pracy urzędnika na jedną sprawę załatwioną przez bota.',
    assumption_many:
      'Przyjęto ostrożnie {{count}} minut pracy urzędnika na jedną sprawę załatwioną przez bota.',
    assumption_other:
      'Przyjęto ostrożnie {{count}} minuty pracy urzędnika na jedną sprawę załatwioną przez bota.',
    // VERIFY: brak w mockupie.
    error: 'Nie udało się wczytać wskaźników.',
  },

  weekday: {
    // VERIFY: mockup ma „Rozmowy według dni tygodnia" i „Średnia z ostatnich 30 dni". Nasza
    // karta liczy tylko rozmowy obsłużone przez asystenta i ma własne okno 30 dni niezależnie
    // od wybranego zakresu, więc tytuł i podpis mówią to wprost.
    title: 'Rozmowy obsłużone przez asystenta, według dni tygodnia',
    hint: 'Średnia dla dnia tygodnia z ostatnich 30 dni, niezależnie od wybranego okresu',
    // Skróty jak na osi w mockupie, poniedziałek pierwszy.
    labels: {
      mon: 'pn',
      tue: 'wt',
      wed: 'śr',
      thu: 'cz',
      fri: 'pt',
      sat: 'so',
      sun: 'nd',
    },
    legend: {
      // VERIFY: brak w mockupie (mockup nie ma legendy pod wykresem dni tygodnia).
      weekdays: 'od poniedziałku do piątku',
      weekend: 'weekend',
    },
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać zestawienia według dni tygodnia.',
      loading: 'Ładowanie zestawienia według dni tygodnia…',
    },
    unavailable: {
      hourly: 'Zestawienie według dni tygodnia wymaga okresu dłuższego niż 24 godziny.',
      empty: 'Brak rozmów w tym okresie.',
      notMeasured: 'Rozmowy obsłużone przez asystenta nie są mierzone dla tej firmy.',
    },
  },

  languages: {
    title: 'Języki rozmów',
    // VERIFY: mockup ma „Rozpoznawane automatycznie na początku połączenia"; druga część
    // (pominięcie rozmów bez rozpoznanego języka) jest własna.
    hint: 'Rozpoznawane automatycznie na początku połączenia. Rozmowy bez rozpoznanego języka są pominięte.',
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać języków.',
      loading: 'Ładowanie języków…',
      empty: 'Brak rozpoznanych języków w tym okresie.',
    },
  },

  // Poniższe trzy karty pokazują dane demo (VITE_SHOW_DEMO_DATA) i mają znaczniki na kartach.
  residentQuestions: {
    title: 'Najczęstsze pytania mieszkańców',
    hint: 'Automatycznie grupowane przez AI — podpowiadają, co dodać do bazy wiedzy',
    columns: {
      question: 'Pytanie',
      occurrences: 'Wystąpienia',
    },
  },

  knowledgeGaps: {
    title: 'Pytania bez odpowiedzi',
    hint: 'Bot przyznał, że nie zna odpowiedzi — uzupełnienie tych tematów najszybciej podnosi skuteczność',
    note: '{{occurrences}}× w wybranym okresie · sugerowany folder: {{folder}}',
    badge: 'do uzupełnienia',
    action: 'Uzupełnij bazę wiedzy',
  },

  handoffReasons: {
    title: 'Powody przekazań do urzędnika',
    hint: 'Dlaczego bot nie zamknął sprawy samodzielnie',
    callout:
      'Spraw z powodem „brak odpowiedzi w bazie wiedzy” będzie mniej po wgraniu brakujących materiałów.',
  },

  callbacks: {
    title: 'Sprawy czekające na oddzwonienie',
    // VERIFY: mockup ma „Przekazane przez bota — z zapisanym numerem telefonu i tematem sprawy";
    // nasza karta mówi, do czego służy kolejka.
    hint: 'Przekazane przez asystenta, aby urzędnik oddzwonił do mieszkańca',
    columns: {
      department: 'Wydział',
      cases: 'Sprawy',
    },
    // VERIFY: cały blok poniżej, brak w mockupie (mockup ma tabelę bez podsumowania i bez
    // podziału na pilność).
    rows: {
      other: 'Inne',
      unassigned: 'Nieprzypisane',
    },
    // `range` to „w ostatnich 7 dniach" (metrics.range.in).
    raised: 'Zgłoszone {{range}}',
    urgency: {
      high_one: '{{count, number}} pilna',
      high_few: '{{count, number}} pilne',
      high_many: '{{count, number}} pilnych',
      high_other: '{{count, number}} pilnej',
      medium_one: '{{count, number}} średnio pilna',
      medium_few: '{{count, number}} średnio pilne',
      medium_many: '{{count, number}} średnio pilnych',
      medium_other: '{{count, number}} średnio pilnej',
      low_one: '{{count, number}} mało pilna',
      low_few: '{{count, number}} mało pilne',
      low_many: '{{count, number}} mało pilnych',
      low_other: '{{count, number}} mało pilnej',
      // Sprawa, która przyszła bez pilności, to nie sprawa mało pilna.
      unset: '{{count, number}} bez określonej pilności',
    },
    messages: {
      error: 'Nie udało się wczytać kolejki oddzwonień.',
      loading: 'Ładowanie kolejki oddzwonień…',
      empty: 'Brak spraw czekających na oddzwonienie w tym okresie.',
    },
  },

  errors: {
    // VERIFY: brak w mockupie.
    metrics: 'Nie udało się wczytać metryk rozmów, więc poniższe dane są niepełne.',
  },

  // Teksty z mockupu dla danych demo (src/demo/demo-data.ts). Kod trzyma klucze, nie treść,
  // żeby `t()` nie wykonywało się przy imporcie modułu.
  demo: {
    questions: {
      childIdCard: 'Jakie dokumenty do dowodu dla dziecka?',
      bulkyWaste: 'Kiedy wywóz gabarytów na mojej ulicy?',
      stampDuty: 'Numer konta do opłaty skarbowej',
      officeAfterHoliday: 'Czy urząd czynny w piątek po święcie?',
      suspendBusiness: 'Jak zawiesić działalność gospodarczą?',
    },
    gaps: {
      cardPayment: 'Czy mogę zapłacić kartą w kasie urzędu?',
      streetLight: 'Jak zgłosić awarię oświetlenia ulicznego?',
      drivingLicence: 'Ile kosztuje wymiana prawa jazdy i jak długo trwa?',
      boilerGrant: 'Czy jest dofinansowanie do wymiany pieca?',
      largeFamilyCard: 'Gdzie wyrobić Kartę Dużej Rodziny?',
    },
    folders: {
      finance: 'Wydział Finansowy',
      utilities: 'Wydział Gospodarki Komunalnej',
      transport: 'Wydział Komunikacji',
      general: 'Zasady ogólne',
    },
    handoffReasons: {
      residentRecord: 'Sprawa wymaga wglądu w dane mieszkańca',
      askedForClerk: 'Mieszkaniec poprosił o rozmowę z urzędnikiem',
      noAnswer: 'Brak odpowiedzi w bazie wiedzy',
      complexCase: 'Sprawa złożona lub nietypowa',
    },
  },
} as const;
